/* eslint no-param-reassign: 0, class-methods-use-this: 0, arrow-body-style: 0 */
import CollectionApi from './CollectionApi';

class WorkdayWorkerApi extends CollectionApi {
  /**
   * @todo Can we pass the Workday ID to the constructor? It seems like this is
   * the most appropriate time to do this. However, to do so implies that
   * instead of exporting a class instance from this file, the class itself is
   * exported. This should be explored as it will make the v2 Api classes
   * more flexible.
   */
  constructor(workdayId = '') {
    super(`/api/v2/workdays/${workdayId}/workers`, {
      skip: 0,
      limit: 50,
      sort: 'lastName',
    });
  }

  /**
   * This method moves the id and hire_date fields from the attributes object
   * to the top level so they can be used as the unique identifier for each worker,
   * and as a top level attribute, respectively.
   */
  moveKeyAttributesToTopLevel(results) {
    return results.map((worker) => {
      // Move hire_date from attributes to be a top level field so it
      // is displayed as a primary column, not in the the expandable
      // preview attributes section.
      if (worker.attributes && worker.attributes.hire_date) {
        worker.hire_date = worker.attributes.hire_date;
        delete worker.attributes.hire_date;
      }

      // Move the Id from the attributes to be the unique identifier
      // of each worker.
      if (worker.attributes && worker.attributes.Id) {
        worker.id = worker.attributes.Id;
        delete worker.attributes.Id;
      }

      return worker;
    });
  }

  setWorkdayId(workdayId) {
    this.baseUrl = `/api/v2/workdays/${workdayId || ''}/workers`;
  }

  fetch(skip, limit, sort, searchTerm) {
    return super.fetch(skip, limit, sort, searchTerm)
      .then((items) => {
        items.results = this.moveKeyAttributesToTopLevel(items.results);
        return items;
      });
  }

  fetchAll(searchTerm) {
    return super.fetchAll(searchTerm)
      .then((results) => {
        return this.moveKeyAttributesToTopLevel(results);
      });
  }
}

export default new WorkdayWorkerApi();
